import { Badge, Card, message, Space, Tag } from "antd";
import { IVideo } from "../../interfaces";
import { IURL } from "./VideoDetail";
import StudioPlayer from "./StudioPlayer";
import { ICourse } from "../../screens/list";
import { RTMP_SERVER, studioApi } from "../../api";
import { useEffect, useState } from "react";
import { useMount } from "../../hooks";
import YoutubeActionButton from "./youtubeActionButtons";
import { statusColor } from "../../utils/constants";
import YoutubeVideoDetails from "./youtubeVideoDetails";
import Engagement from "../../utils/engagement";
import dayjs from "dayjs";
import StudioVideoDetails from "../../screens/studioVideoDetails";
import DelayFormModal from "../delay/delayFormModal";


type TProps = {
  video: IVideo;
  onDone: (video: IVideo) => void;
  frameKey: number;
  course: ICourse;
  player: "old" | "new";
  setPlayer: (player: "old" | "new") => void;
};

function YoutubeLiveStudio({
  video,
  onDone,
  frameKey,
  course,
  player,
  setPlayer,
}: TProps) {
  const [playerUrls, setPlayerUrls] = useState<IURL[]>([]);
  const [activeUrl, setActiveUrl] = useState(playerUrls[0]);
  const [activeTab, setActiveTab] = useState<
    "details" | "engagement" | "admin" | "delay"
  >("details");

  useMount(() => {
    const urls = [
      {
        label: "RTMP Video",
        value: `${localStorage.getItem("live_CDN") || RTMP_SERVER}/hls/${
          video.stream_key
        }.m3u8&is_live=1`,
      },
    ];
    setPlayerUrls(urls);
    setActiveUrl(urls[0]);
  }, [video?.stream_key]);
  const tabs = [
    {
      key: "details",
      label: "Video Details",
    },
    {
      key: "admin",
      label: "Admin Details",
    },
    {
      key: "engagement",
      label: "Engagement",
    },
  ] as const;
  const [videoDetails, setVideoDetails] = useState<any>(null);

  const [isDelayModalOpen, setIsDelayModalOpen] = useState(false);

  const getVideoDetails = async () => {
    try {
      const { data } = await studioApi.get(`/cms/videos/${video.vid}`);

      setVideoDetails(data);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch video details");
    }
  };
  useEffect(() => {
    if (video?.vid) {
      getVideoDetails();
    }
  }, [video?.vid]);

  useEffect(() => {
    if (!videoDetails) return;
    const publishedAt = videoDetails?.published_at;
    const startAt = videoDetails?.details?.start_at;
    const delayMsg = videoDetails?.details?.delay_msg;
    if (!publishedAt || !startAt) return;
    const diffMinutes = dayjs(startAt).diff(dayjs(publishedAt), "minute", true);
    if (diffMinutes > 2 && delayMsg == null) {
      setIsDelayModalOpen(true);
    }
  }, [videoDetails]);
  return (
    <div
      style={{
        overflow: "scroll",
        height: "100%",
        width: "100%",
      }}
    >
      <Card
        title={`# ${video?.vid} Video Details`}
        type="inner"
        style={{ overflow: "hidden", marginBottom: 10, padding: 0 }}
        extra={
          <Space>
            {/* {video.status === "live" && (
              <Tag
                style={{
                  background: "#FF0000",
                  color: "#FFFFFF",
                  border: "none",
                  borderRadius: "16px",
                  padding: "4px 12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  margin: 0,
                  height: "32px",
                }}
              >
                <Badge
                  status="processing"
                  color="#FFFFFF"
                  style={{ marginRight: "4px" }}
                />
                <span style={{ fontWeight: 700, fontSize: "11px" }}>LIVE</span>
              </Tag>
            )} */}
            <Tag color={statusColor[`${video.status}`]}>
              <Badge
                color={
                  video.status === "rendering"
                    ? "orange"
                    : video.status === "live"
                    ? "green"
                    : "#A9A9A9"
                }
                text={video.status}
              />
            </Tag>
            <YoutubeActionButton onDone={onDone} video={video} />
          </Space>
        }
      >
        {video.stream_key !== undefined && (
          <StudioPlayer
            player={player}
            key={frameKey}
            videoUrl={video.videoType === "youtube" ? video.liveUrl : video.url}
          />
        )}

        <div className="flex items-center gap-2 mb-4 border-b border-slate-200 pb-3 my-4">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all cursor-pointer ${
                activeTab === tab.key
                  ? "bg-blue-900 text-white shadow-sm"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        {activeTab === "details" && (
          <div className="">
            <YoutubeVideoDetails
              player={player}
              setPlayer={setPlayer}
              playerUrls={playerUrls}
              activeUrl={activeUrl}
              onChangeUrl={() => console.log("unable to change url")}
              latest={video}
              course={course!}
            />
          </div>
        )}
        {activeTab === "engagement" && <Engagement roomId={video?.vid} />}

        {activeTab === "admin" && (
          <StudioVideoDetails vId={video?.vid!} status={true!} streamKey={video?.stream_key!} />
        )}
        <DelayFormModal
          open={isDelayModalOpen}
          onSuccess={() => {
            setIsDelayModalOpen(false);
            getVideoDetails();
          }}
          videoId={video.vid!}
        />

      </Card>
    </div>
  );
}

export default YoutubeLiveStudio;
